import { AxiosResponse } from 'axios';

import { UDNICK } from '../../../../../../../../service/udnick';

export interface IAgendamentoEdited {
  codAgendamento: number;
  codCdd: number;
  codEmp: number;
  codHorario: number;
  codMotorista: number;
  codOrdemCarga: number;
  codVeiculo: number;
  codTransportadora: number;
  codCliente: number;
  status: string;
  centroDistribuicao: string;
  cliente: string;
  dhAgendamento: Date | string;
  placa: string;
  transportadora: string;
  pesoBruto: number;
  valor: number;
  tipoWms: string;
  plataforma: string;
  dhAguardando: Date | string;
  dhChegada: Date | string;
  dhEntrada: Date | string;
  dhSaida: Date | string;
  clienteRetira: boolean;
  assoalho: string;
  motorista: string;
}

export const EditarOrdemDeColetaServices = {
  alterarAgendamento: (
    codAgendamento: number,
    status: string,
    codCdd: number,
    codTransportadora?: number,
    codMotorista?: number,
    codVeiculo?: number,
    codTipoCarroceria?: number,
    dhAgendamento?: string,
    codCliente?: number,
    clienteRetira?: boolean,
    codOrdemCarga?: number
  ): Promise<AxiosResponse<IAgendamentoEdited>> =>
    UDNICK.callService('alterarAgendamento', {
      agendamento: {
        status,
        codAgendamento,
        codCdd,
        codMotorista,
        codTipoCarroceria,
        codVeiculo,
        dhAgendamento,
        codTransportadora,
      },
    }),
};

export const ListarMotoristaOrdemDeColetaServices = {
  getMotoristaPortal: (parceiros: number[]): Promise<AxiosResponse> =>
    UDNICK.callService('getMotoristaPortal', {
      parceiros,
    }),
};
export const ListarVeiculosOrdemDeColetaServices = {
  getVeiculosPortal: (parceiros: number[]): Promise<AxiosResponse> =>
    UDNICK.callService('getVeiculosPortal', {
      parceiros,
    }),
};

export const getTipoVeiculos = {
  getTipoVeiculos: (): Promise<AxiosResponse> => UDNICK.callService('getTipoVeiculos', {}),
};
